function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/team/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'team')
    }
}

let routes = [
    {
        name: 'teamListNew',
        path: '/ems/team/teamListNew',
        meta: {
            title: '团队'
        }
    },
    {
        name: 'subUsersList',
        path: '/ems/team/subUsersList',
        meta: {
            title: '账号列表'
        }
    },
    {
        name: 'applyTeam',
        path: '/ems/team/applyTeam',
        meta: {
            title: '加入组织'
        }
    },
    {
        name: 'authentication',
        path: '/ems/team/authentication',
        meta: {
            title: '实名认证'
        }
    },
    {
        name: 'checkUser',
        path: '/ems/team/checkUser',
        meta: {
            title: '团队成员信息'
        }
    },
    {
        name: 'teamDetail',
        path: '/ems/team/teamDetail',
        meta: {
            title: '人员详情'
        }
    },
    {
        name: 'teamMsg',
        path: '/ems/team/teamMsg',
        meta: {
            title: '加入团队'
        }
    },
    {
        name: 'applyUserList',
        path: '/ems/team/applyUserList',
        meta: {
            title: '新的成员'
        }
    },
    {
        name: 'editUserMsg',
        path: '/ems/team/editUser',
        meta: {
            title: '团队成员信息'
        }
    },
    {
        name: 'editWorkMsg',
        path: '/ems/team/editWork',
        meta: {
            title: '工作信息'
        }
    },
    
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/team.js